export function InternalError(status, code, message) {
  this.status = status;
  this.code = code;
  this.message = message;
  this.name = this.constructor.name;
}

InternalError.prototype = _.create(Error.prototype);


export default function parseError(response) {
  if (response instanceof InternalError) {
    return Promise.reject(parseInternalError(response));
  }

  return Promise.reject(parseNativeError(response));
}


function parseInternalError({ status, code, message } = {}) {
  return {
    status,
    error: {
      code,
      message,
    },
  };
}


function parseNativeError(response) {
  const { status, data } = response;

  return {
    status,
    error: data.error,
  };
}



// WEBPACK FOOTER //
// ./src/transport/adapters/facebook/parsers/error.js